<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M15.5 7H.5a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 .5 0h15a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5zm-4-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm4 14H.5a.5.5 0 0 1-.5-.5v-6A.5.5 0 0 1 .5 9h15a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5zm-4-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" fill="currentColor"/><path d="M14 7.001v2H2v-2h12Z" opacity=".45" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-prodoffering02',
});
</script>
